import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { ContentCard } from 'components/ContentCard';
import { Breadcrumb } from 'components/ui/Breadcrumb';
import { ROUTES } from 'constants/routes';
import type { WellbeingTypes } from 'constants/wellbeing';
import { useWellbeingContent } from 'hooks/useWellbeingContent';
import { DEFAULT_CATEGORY } from 'pages/WellBeingContent/types';
import type { Wellbeing } from 'types/wellbeing';
import { CategoryFilter } from '../CategoryFilter';

export const ContentDefault = (): React.ReactElement | null => {
  const { id } = useParams();
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);
  const { data: content, isLoading } = useWellbeingContent(id as WellbeingTypes);
  const [selectedCategory, setSelectedCategory] = useState(DEFAULT_CATEGORY);

  const getFilteredContent = (): Wellbeing[] | undefined => {
    if (selectedCategory === DEFAULT_CATEGORY) {
      return content;
    }
    return content?.filter(item => item.tags?.some(tag => tag === selectedCategory));
  };

  if (isLoading) return <LoadingScreen />;

  if (!id) return null;

  return (
    <div className="flex flex-col gap-8">
      <Breadcrumb
        links={[
          { href: ROUTES.WELL_BEING, label: t('Nav.wellBeing', { ns: LOCIZE_NS.COMMON }) },
          { href: `${ROUTES.WELL_BEING}/${id}`, label: t(`WellBeingContent.${id}.heading`) || id },
        ]}
      />
      <CategoryFilter
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        content={content}
      />
      <div className="bg-white rounded-lg shadow-sm border p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 am-xl:grid-cols-3 2xl:grid-cols-4 gap-4 justify-items-center">
          {getFilteredContent()?.map(item => (
            <ContentCard key={item.title} {...item} />
          ))}
        </div>
      </div>
    </div>
  );
};
